import React from "react";
import "./Game_History_card.css";

function Game_History_card({ data }) {
  return (
    <section className="Game_History_card">
      <div className="history_card">

        {/* Header */}
        <div className="card_header_holder">
          <div className="history_header">
            <div className="game_title">{data.game}</div>
            <div className={`game_result ${data.resultClass}`}>
              {data.result}
            </div>
          </div>

          <div className="history_time">{data.time}</div>
        </div>

        {/* Details */}
        <div className="history_details">

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Type</span>
            <span className="value">{data.type}</span>
          </div>

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Period</span>
            <span className="value">{data.period}</span>
          </div>

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Order number</span>
            <span className="value">{data.order}</span>
          </div>

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Select</span>
            <span className="value">{data.select}</span>
          </div>

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Total Bet</span>
            <span className="value">{data.totalBet}</span>
          </div>

        </div>

        <div className="divider"></div>

        {/* Lottery Result */}
        <div className="history_details">

          <div className="detail_row">
            <span className="timeline_point"></span>
            <span className="label">Lottery Results</span>
          </div>

          <div className="detail_row">
            <span className="timeline_point"></span>

            <div className="lottery_result">

              <div className="boll_img_holder">
                <div className="number_circle">
                  <img
                    src={data.ballImage}
                    className="num_img"
                    alt="ball"
                  />
                </div>
              </div>

              <div className="tags">
                {data.tags.map((tag, index) => (
                  <span key={index} className={`tag ${tag.class}`}>
                    {tag.text}
                  </span>
                ))}
              </div>

            </div>

          </div>

        </div>

        {/* Amount Grid */}
        <div className="amount_grid">

          <div className="amount_box">
            <div className="amount">{data.actualAmount}</div>
            <div className="amount_label">Actual Amount</div>
          </div>

          <div className="amount_box">
            <div className="amount">{data.winnings}</div>
            <div className="amount_label">Winnings</div>
          </div>

          <div className="amount_box">
            <div className="amount">{data.fee}</div>
            <div className="amount_label">Handling Fee</div>
          </div>

          <div className="amount_box">
            <div className={`amount ${data.profitClass}`}>
              {data.profit}
            </div>
            <div className="amount_label">Profit/Loss</div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Game_History_card;